/* Posterized home - the live builder cards (Arjun 09-14/15): on a Mix & Match / Build Your Wall card
   the pointer hand taps sheet after sheet, each ghost design fills solid, then the wall resets. One
   hand per row - the first card that is mostly on screen - so a row of live packs never runs five
   hands at once; swiping the row hands it to the next card. Visibility is measured from the
   boxes on a light timer + scroll/resize (an IntersectionObserver set up at load missed cards on
   the draft's home page - 09-15); cards that appear later are picked up, removed ones dropped.
   Nothing moves under reduced motion; the markup is static (snippets/pz-home-live.liquid), so
   without this script every card is still a wall. */
(function () {
  if (window.__pzLive) return;
  window.__pzLive = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var cards = [];
  function make(live) {
    var card = live.parentNode, hand = card && card.querySelector('.hand'), ph = live.querySelector('img.ph');
    var gs = [].slice.call(live.querySelectorAll('i, image.g'));   /* sheets: <i> on the photo cards, ghost <image>s in the builder's drawn scenes (17-09) */
    if (!hand || gs.length < 2) return null;
    /* six sheets spread over the wall, not one row */
    var order = [], n = Math.min(gs.length, 6);
    for (var j = 0; j < n; j++) order.push(Math.round(j * gs.length / n));
    var idx = 0, timers = [], running = false, run = 0, rounds = 0, done = false;
    var T = function (fn, ms) { timers.push(setTimeout(fn, ms)); };
    /* the fingertip (8,2 of the pointer's 24-unit box = 10px,2.5px of the 30px hand) lands a little above the sheet's centre.
       17-09: moved with transform, never left/top - a layout change inside the builders' scroll-snap rail made iOS Safari
       re-snap and nudge the page (the sticky header kept sliding in and out). --pz-hand-scale shrinks it on small cards;
       transform-origin 10px 2.5px keeps the fingertip in place when scaled. */
    var sc = parseFloat((window.getComputedStyle(hand).getPropertyValue('--pz-hand-scale') || '').trim()) || 1;
    function place(g) {
      var cr = card.getBoundingClientRect(), r = g.getBoundingClientRect();
      var x = r.left - cr.left + r.width * 0.5 - 10, y = r.top - cr.top + r.height * 0.45 - 2.5;
      hand.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)' + (sc !== 1 ? ' scale(' + sc + ')' : '');
    }
    function step() {
      if (!running) return;
      hand.classList.remove('pulse');
      if (idx >= order.length) {
        /* Arjun 18-09 (phone heat): two rounds, then the card rests */
        var last = ++rounds >= 2;
        T(function () {
          gs.forEach(function (g) { g.classList.remove('on'); });
          hand.classList.remove('show'); idx = 0;
          if (last) { done = true; running = false; return; }
          T(step, 900);
        }, 1600);
        return;
      }
      var g = gs[order[idx]];
      place(g);
      hand.classList.add('show');
      T(function () { hand.classList.add('tap'); hand.classList.add('pulse'); g.classList.add('on'); }, 600);
      T(function () { hand.classList.remove('tap'); }, 800);
      T(function () { idx++; step(); }, 1250);
    }
    return {
      live: live,
      row: (live.closest && live.closest('.row, .pz-wb-sizes')) || null,   /* the builders' pack rail counts as a row too (17-09) */
      isDone: function () { return done; },
      start: function () {
        if (running || done) return;
        running = true;
        var mine = ++run;
        /* the photo first, then the hand */
        if (ph && !ph.complete) { ph.addEventListener('load', function () { if (running && mine === run) T(step, 400); }); return; }
        T(step, 400);
      },
      stop: function () {
        if (!running) return;
        running = false;
        timers.forEach(clearTimeout);
        timers = [];
        idx = 0;
        gs.forEach(function (g) { g.classList.remove('on'); });
        hand.classList.remove('show');
        hand.classList.remove('tap');
        hand.classList.remove('pulse');
      }
    };
  }
  /* the share of the card on screen, clipped by its scrolling row */
  function ratioOf(c) {
    var r = c.live.getBoundingClientRect();
    if (!r.width || !r.height) return 0;
    var x0 = Math.max(r.left, 0), x1 = Math.min(r.right, window.innerWidth);
    var y0 = Math.max(r.top, 0), y1 = Math.min(r.bottom, window.innerHeight);
    if (c.row) { var k = c.row.getBoundingClientRect(); x0 = Math.max(x0, k.left); x1 = Math.min(x1, k.right); }
    return Math.max(0, x1 - x0) * Math.max(0, y1 - y0) / (r.width * r.height);
  }
  function scan() {
    cards = cards.filter(function (c) { if (document.body.contains(c.live)) return true; c.stop(); return false; });
    [].slice.call(document.querySelectorAll('.pz-live')).forEach(function (live) {
      if (live.__pzLive) return;
      live.__pzLive = true;
      var c = make(live);
      if (c) cards.push(c);
    });
  }
  function pick() {
    /* nothing runs in a hidden tab or behind the open picker (html.pz-wb-lock) */
    if (document.hidden || document.documentElement.classList.contains('pz-wb-lock')) { cards.forEach(function (c) { c.stop(); }); return; }
    var busy = [];
    cards.forEach(function (c) {
      var key = c.row || c.live;
      if (!c.isDone() && ratioOf(c) >= 0.6 && busy.indexOf(key) < 0) { busy.push(key); c.start(); }
      else c.stop();
    });
  }
  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; pick(); });
  }
  scan();
  pick();
  window.addEventListener('scroll', soon, { passive: true, capture: true });   /* capture: the rows' own horizontal scrolls too */
  window.addEventListener('resize', soon);
  window.addEventListener('load', function () { scan(); pick(); });
  document.addEventListener('visibilitychange', pick);
  if (window.MutationObserver) new MutationObserver(soon).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  setInterval(function () { scan(); pick(); }, 1500);
})();
